module.exports = __webpack_public_path__ + "static/img/bg-en.cf30fe89.png";